import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TFacilityForm, TVariantForm } from "redux/reducers/models/facility";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/client/form";

type TGetFacilityForm = {
  id?: string | number;
  variant_ids?: Array<number>;
};

type TPostFacilityForm = {
  title: string;
};

type TPutFacilityForm = {
  id: string | number;
  title?: string;
};

type TPutVariantForm = {
  variant_id: string | number;
  form_id: string | number;
};

// GET Forms
export async function GetFacilityForm(params: TGetFacilityForm, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TFacilityForm[] | TVariantForm[]>(
    APIUrl(AdminType.FacilityAdmin, "/client/form"),
    params,
    useGlobalLoader,
    token,
  );
}

// POST Form
export async function PostFacilityForm(params: TPostFacilityForm, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/client/form"), params, useGlobalLoader);
}

// PUT Forms
export async function PutFacilityForm(params: TPutFacilityForm, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/form"), params, useGlobalLoader);
}

export async function AddFormToVariant(params: TPutVariantForm, useGlobalLoader: true) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/form/variant"), params, useGlobalLoader);
}

export async function RemoveFormFromVariant(params: TPutVariantForm, useGlobalLoader: true) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/client/form/variant"), params, useGlobalLoader);
}
